import { store } from "../../store";
import {
  addAppointment,
  updateAppointment,
  removeAppointment
} from "../../ReduxSlices/Appointments/appointmentsSlice";
import subscribeToCoreUpdates from "../core_updates_channel";

let unsubscribeAppointments = null; // store unsubscribe function

export const initializeAppointmentsSubscription = () => {
  if (unsubscribeAppointments) return; // Already subscribed

  // Pass a unique module key as first argument
  unsubscribeAppointments = subscribeToCoreUpdates("appointments", {
    "appointment.created": (data) => store.dispatch(addAppointment(data)),
    "appointment.updated": (data) => store.dispatch(updateAppointment(data)),
    "appointment.deleted": (data) => store.dispatch(removeAppointment(data.id)),
  });

 // console.log("✅ Appointments subscription initialized");
};

export const unsubscribeAppointmentsSubscription = () => {
  if (unsubscribeAppointments) {
    unsubscribeAppointments(); // call the unsubscribe function
    unsubscribeAppointments = null;
   // console.log("🔌 Appointments subscription removed");
  }
};